import { Component, OnInit } from '@angular/core';
import { HttpserviceService } from '../../service/http.service.service';
import { Router } from '@angular/router';
import { UtilsService } from '../../service/utils.service';
import { GlobalConfig } from '../../entities/global-config';
import { BsModalRef } from 'ngx-bootstrap';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../service/auth.service';
import { SpinnerService } from '../../service/spinner.service';
declare var moment: any;
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  guidId: any = '';
  apiUrl: any = '';
  resetForm: FormGroup;
  formErrors: any;
  submitted: Boolean = false;
  agents: any[] = [];
  isEdit: Boolean = false;
  public currentDate: any;
  public expiryDate: any;
  constructor(
    private route: ActivatedRoute,
    private servicesComponent: HttpserviceService,
    private router: Router,
    private utilsService: UtilsService,
    private config: GlobalConfig,
    private toastr: ToastsManager,
    private authService: AuthService,
    private spinnerService: SpinnerService,
  ) {
    this.currentDate = moment().format('DD-MM-YYYY, h:mm:ss a');
  }
  user: any = {
    passwordResetToken: '',
  };

  reset: any = {
    id: 0,
    passwordHash: '',
    confirmpassword: '',
  };

  ngOnInit() {
    this.user.passwordResetToken = this.route.snapshot.params['id'];
    if (this.user.passwordResetToken !== "" && this.user.passwordResetToken != null) {
      this.getExpiryToken();
    }
  }

  getExpiryToken() {
    this.spinnerService.displayLoader(true);
    this.authService.getExpiryToken(this.user.passwordResetToken)
      .then((response: any) => {
        this.reset = response;
        this.spinnerService.displayLoader(false);
        if (response != null && response !== '') {
          var momentObj = moment(response.passwordTokenExpiry);
          this.expiryDate = momentObj.format('DD-MM-YYYY, h:mm:ss a');
          this.currentDate = moment().format('DD-MM-YYYY, h:mm:ss a').locale;
          if (this.currentDate > this.expiryDate) {
            this.router.navigate(['./forgot-password']);
            this.toastr.info('your token expire please try again.', 'Success!');
          }
        }
        else {
          this.router.navigate(['./forgot-password']);
          this.toastr.error('please try again.', 'Error!');
        }
      })
      .catch(error => {
        this.spinnerService.displayLoader(false);
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }
  resetPassword(form) {
    this.submitted = false;
    if (form.valid) {
      this.spinnerService.displayLoader(true);
      if (this.reset.passwordHash !== this.reset.confirmpassword) {
        this.spinnerService.displayLoader(false);
        this.toastr.info("New Password and Confirm Password Don't not match.", 'Info!');
        return;
      }
      else {
        this.authService.resetPassword(this.reset)
          .then((response: any) => {
            this.spinnerService.displayLoader(false);
            if (response.success == true) {
              this.router.navigate(['./login']);
              this.toastr.success('password changed successfully.', 'Success!');
            }
            else {
            
              this.toastr.success('password changed successfully.', 'Success!');
            }
          })

          .catch(error => {
            this.spinnerService.displayLoader(false);
            console.log(error);
            this.toastr.error('Some error occured, Please contact admin.', 'Error!');
          });
      }
    } else {
      this.submitted = true;
    }
  }
}




// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/DubaisaleV1/cpapi.v1/CPDubaisaleApp/src/app/auth/reset-password/reset-password.component.ts